import Layout from './components/Layout'
import App from './containers/App'
import Login from './containers/Login'
import SubscriberView from './containers/SubscriberView'
import ActiveCallList from './containers/ActiveCallList'
import ConnectView from './containers/ConnectView'
import CallHistory from './containers/CallHistory'
import EditView from './containers/EditView'
import StaticPage from './components/StaticPage'
import Maintenance from './containers/Maintenance'

export default {
    path: '/',
    component: Layout,
    childRoutes: [
        {
            component: App,
            indexRoute: { component: SubscriberView },
            childRoutes: [
                { path: 'calls', component: ActiveCallList },
                { path: 'connect/:subscriberId', component: ConnectView },
                { path: 'history/:subscriberId', component: CallHistory },
                { path: 'edit/:subscriberId', component: EditView },
                { path: 'create', component: EditView },
                { path: 'help', component: StaticPage },
                { path: 'maintenance', component: Maintenance }
            ]
        },
        { path: 'login', component: Login },
    ]
}


// WEBPACK FOOTER //
// ./routes.js